class EditShiftSuccessModalController {
  /* @ngInject */
  constructor ($mdDialog, bodyText, title) {
    this.$mdDialog = $mdDialog;
    this.title = title;
    this.bodyText = bodyText;
  }

  cancel = () => {
    this.$mdDialog.cancel();
  }
}

export default EditShiftSuccessModalController;
